export function reportShareUrl(reportId: string): string {
  return `${window.location.origin}/reports/${reportId}`;
}
